import React, { useState, useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import '../Login.css';
import { sendAsyncRequest } from '../../../services/AsyncRequestService';
import { cognitoLoginSuccess } from '../../../services/AuthService';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'components/Spinner';
import Alert from 'react-bootstrap/Alert';

const LoginCallback = () => {
  const [redirectToReferrer, setRedirectToReferrer] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const onLoginSuccess = (response) => {
      let data = response.data;
      let userObjToSave = {
        uuid: data.uuid,
        name: data.name,
        authorities: data.authorities,
        email: data.email,
        tableAttributes: data.tableAttributes,
      };
      cognitoLoginSuccess(
        userObjToSave,
        data.commitVersionId,
        data.currentReleaseNumber,
        data.deviceKey,
        data.currentTimeMillis,
        data.idTokenDurationSecs,
        data.csrfToken
      );
      setRedirectToReferrer(true);
    };

    const onLoginFailure = (error) => {
      setError("Something went wrong");
    };

    const handleLogin = (code) => {
      let url = "/login/oauth2/code/cognito?code=" + code;
      let method = "GET";
      sendAsyncRequest(url, method, null, onLoginSuccess, onLoginFailure);
    };

    const query = new URLSearchParams(location.search);
    let code = query.get("code");
    handleLogin(code);
  }, [location.search]);

  const { from } = location.state || { from: { pathname: '/' } };

  if (redirectToReferrer) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="">
      <Container fluid>
        <Row>
          <Col className="text-align-center" md={{ span: 4, offset: 4 }}>
            {error ? <Alert variant="danger">{error}</Alert> : <Spinner />}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginCallback;
